import { Breadcrumbs, Button, Container, Link, Stack, Typography } from "@mui/material";
import MenuMenu from "./MenuMenu";
import Iframe from 'react-iframe'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const D0141OperatingOrganization = () => {
  return (
    <>
      <MenuMenu sel={0} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{paddingLeft:"0", paddingRight:"0"}}>
                <Stack spacing={2}>

                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{fontSize:"14px"}}>
                      TOP
                    </Link>,
                    <Typography key="2" color="text.primary" style={{fontSize:"14px"}}>
                      運営組織
                    </Typography>
                  </Breadcrumbs>

                  <h1>運営組織</h1>
                  <p class="table-title">農林水産省</p>
                  <p>
                    〒100-8950 東京都千代田区霞が関1-2-1 「
                    <Link
                      href="https://maps.google.com/maps?ll=35.673987,139.751907&z=17&t=m&hl=ja&gl=JP&mapclient=embed&q=%E3%80%92100-8950"
                      target="_blank"
                    >地図</Link>」
                    <br />林野庁（〒100-8952）
                    <br />水産庁（〒100-8907）
                    <br />電話：03-3502-8111（代表）
                  </p>
                  <div>
                    <Iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2291.825798843442!2d139.75047554040785!3d35.673773120377895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188bf32be4448f%3A0x5a355f44195d73ee!2z44CSMTAwLTg5NTA!5e0!3m2!1sja!2sjp!4v1671770628092!5m2!1sja!2sjp"
                      width="100%" height="450" style="border:0;"
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    />
                  </div>
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default D0141OperatingOrganization;
